import type { AnimationProperties, AnimationsKit } from '../../types';

const name = 'NoTransition';
const properties: AnimationProperties = {
  defaultDuration: 0,
  schema: {
    duration: {
      type: 'number',
      min: 0,
      default: 0,
    },
    delay: {
      type: 'number',
      min: 0,
      default: 0,
    },
  },
};

/**
 * Empty transition.
 */
function transition(
  kit: AnimationsKit,
  sourceElements: HTMLElement[] | HTMLElement | HTMLCollection,
  destElements: HTMLElement[] | HTMLElement | HTMLCollection,
  duration?: number,
  delay?: number,
  params?: any,
) {
  const sequence = kit.sequence(params);
  sequence.add([
    kit.animate('BaseNone', sourceElements, duration, delay),
    kit.animate('BaseNone', destElements, duration, delay),
  ]);

  return sequence.get();
}

export { name, properties, transition };
